function generateLucideClass(apiIcon, id) {
  if (apiIcon && apiIcon !== "candy") return apiIcon;

  const icons = [
    "icon-notebook-text", // Represents literacy, written language
    "icon-feather", // Traditional writing, manuscripts
    "icon-scroll-text", // Historical scripts, classical texts
    "icon-candy", // Calligraphy, script writing
    "icon-cannabis", // Writing, modern script usage
    "icon-atom",
    "icon-earth", // Language translation
    "icon-text", // Written communication
    "icon-notebook-text", // Learning a language
    "icon-anvil", // Refinement of language, script adjustments
    "icon-library", // Collection of languages, texts
    "icon-file-text", // Written records, official documents
    "icon-globe", // World languages
    "icon-hourglass", // Timeless nature of languages
    "icon-cat", // Proper language usage
    "icon-brain-circuit", // Language learning, cognition
    "icon-biceps-flexed", // Writing and note-taking
    "icon-dna", // Direction, wayfinding (can apply to language navigation)
    "icon-amphora", // Saving words, bookmarking learning materials
    "icon-stamp", // Official stamps, signifying scripts
    "icon-shell",
    "icon-fish",
  ];

  const index = (id - 1) % icons.length;
  return icons[index];
}

export default generateLucideClass;
